module.exports = __webpack_public_path__ + "img/comment3.cb1b907e.png";